import {
    SocketDisconnectedError,
    SocketTimeoutError,
    classifyServerError,
} from './errors';

const DEFAULT_TIMEOUT_MS = 10000;

// Emit an event with an ack callback, wrapped in a Promise.
//
// Resolves with the server's ack payload on success.
// Rejects with one of the typed errors from ./errors.js:
//   - SocketDisconnectedError if the socket is not connected at call time.
//   - SocketTimeoutError if the server doesn't ack within timeoutMs.
//   - SocketAuthError      if the server returns an auth-class error code.
//   - SocketServerError    for any other { ok: false, error } response.
//
// Callers that want retry / queue behaviour should use emitWithRetry from
// ./queue.js instead.
export function emitWithAck(socket, event, data, timeoutMs = DEFAULT_TIMEOUT_MS) {
    return new Promise((resolve, reject) => {
        if (!socket || !socket.connected) {
            reject(new SocketDisconnectedError());
            return;
        }

        const timer = setTimeout(() => {
            reject(new SocketTimeoutError());
        }, timeoutMs);

        socket.emit(event, data, (response) => {
            clearTimeout(timer);
            if (response && response.ok === false) {
                reject(classifyServerError(response.error));
                return;
            }
            resolve(response);
        });
    });
}
